import { Component, OnInit, ViewChild, ElementRef, Renderer2 } from "@angular/core";

import { TeamsService } from "../teams.service";
import { Router } from "@angular/router";

import { environment } from "../../../environments/environment";
import { LoaderService } from "src/app/loader/loader.service";
import * as moment from "moment";
import { User } from "src/app/users/models/user";
import { UsersService } from "src/app/users/users.service";
import { IDropdownSettings } from "ng-multiselect-dropdown";
import { EquipeModel } from "../models/equipe-model";

@Component({
  selector: "app-teams-add",
  templateUrl: "./teams-add.component.html",
  styleUrls: ["./teams-add.component.scss"],
})
export class TeamsAddComponent implements OnInit {
  env;
  team: EquipeModel;
  users: User[];
  members: User[];
  supervisors: User[];
  allSupervisors: User[];
  allMembers: User[];

  dropdownList = [];
  dropdownSettings: IDropdownSettings = {};
  selectedCompanies = [];

  timeoutIDError;
  timeoutIDWarn;

  @ViewChild("alertError", { read: ElementRef, static: false })
  alertError: ElementRef;

  @ViewChild("alertWarn", { read: ElementRef, static: false })
  alertWarn: ElementRef;

  constructor(
    private teamsService: TeamsService,
    private usersService: UsersService,
    private router: Router,
    private loaderService: LoaderService,
    private renderer: Renderer2
  ) {
    this.env = environment;
  }

  ngOnInit() {
    this.setCompaniesDropdown();
    this.addNewTeam();
  }

  addErrorAlert(msg: string) {
    clearTimeout(this.timeoutIDError);

    this.renderer.setProperty(this.alertError.nativeElement, "innerHTML", msg);
    this.renderer.setProperty(this.alertError.nativeElement, "hidden", false);

    this.timeoutIDError = setTimeout(_ => {
      this.renderer.setProperty(this.alertError.nativeElement, "hidden", true);
    }, 8000);
  }

  addWarnAlert(msg: string) {
    clearTimeout(this.timeoutIDWarn);

    this.renderer.setProperty(this.alertWarn.nativeElement, "innerHTML", msg);
    this.renderer.setProperty(this.alertWarn.nativeElement, "hidden", false);

    this.timeoutIDWarn = setTimeout(_ => {
      this.renderer.setProperty(this.alertWarn.nativeElement, "hidden", true);
    }, 8000);
  }

  onSubmit() {
    this.handleTeamSubmitData();
    this.addTeam(this.team);
  }

  private handleTeamSubmitData() {
    this.team.membros = this.team.membros.filter(member => {
      return !member.deleted;
    });

    this.team.membros = this.team.membros.map(member => {
      const { _id } = member;
      return { _id };
    });

    this.team.empresas = this.selectedCompanies.map(company => {
      const companyData = this.env.user.empresas.filter(companyValue => companyValue.cnpj === company.cnpj)[0];
      return { _id: companyData._id };
    });

    this.team.empresas.sort();
  }

  async addTeam(team: EquipeModel) {
    const loader = await this.loaderService.notifica({
      title: "Salvando equipe...",
      date: moment().toISOString(),
      type: "loading",
    });

    const newTeam = await this.teamsService.addTeam(team).toPromise();

    if ("error" in newTeam) {
      this.addErrorAlert(newTeam.error);
    } else {
      this.router.navigateByUrl(`/teams/${this.env.selected.cnpj}`);
    }

    loader.dismiss();
  }

  addNewTeam() {
    this.team = {
      nome: "",
      supervisor: "",
      gestor: "",
      membros: [{ _id: "", email: "", deleted: false }],
      empresas: [],
      deleted: false,
    };
  }

  addNewMember() {
    const emptyMembers = this.team.membros.filter(member => {
      return member._id === "" && !member.deleted;
    }).length;

    if (emptyMembers === 0) {
      this.team.membros.push({ _id: "", email: "", deleted: false });
    } else {
      this.addWarnAlert("Preencha o nome do novo membro antes de adicionar um novo.");
    }
  }

  deleteMember(index) {
    const numberOfMembers = this.team.membros.filter(member => {
      return !member.deleted;
    }).length;

    if (numberOfMembers > 1) {
      this.team.membros[index].deleted = true;
    } else {
      this.addWarnAlert("Equipe deve ter ao menos um membro.");
    }
  }

  onChangeMember(id: string) {
    const user = this.users.filter(user => user._id === id)[0];

    if (user) {
      this.team.membros.map((member, index) => {
        if (member._id === id) {
          this.team.membros[index].email = user.email;
        }
      });
    }
  }

  setCompaniesDropdown() {
    this.dropdownList = this.env.user.empresas;
    this.selectedCompanies = [this.env.selected];
    this.dropdownSettings = {
      singleSelection: false,
      idField: "cnpj",
      textField: "fantasia",
      selectAllText: "Selecionar Todos",
      unSelectAllText: "Deselecionar Todos",
      itemsShowLimit: 4,
      allowSearchFilter: true,
      searchPlaceholderText: "Pesquisar",
    };
  }

  async onChangeCompanies(companies: any[]) {
    let allUsers: User[] = [];
    const getCompaniesUsers = companies.map(company => {
      return this.usersService.getUsers(company.cnpj).toPromise();
    });

    //-- Get all users by company
    const companiesUsers = await Promise.all([...getCompaniesUsers]);

    //-- Flat array by company to an array with all users
    companiesUsers.forEach(companyUsers => allUsers.push(...companyUsers));

    //-- Remove duplicates users and check if users have all companies permissions
    this.users = allUsers.reduce((users, currentUser) => {
      return users.every(user => user._id !== currentUser._id) &&
        companies.every(
          company => currentUser.empresas.find(userCompany => userCompany.cnpj === company.cnpj) !== undefined
        )
        ? [...users, currentUser]
        : users;
    }, []);

    await this.filterUsersByProfile(this.users);

    //-- Clean up model
    this.addNewTeam();
  }

  onChangeTipoEquipe(tipo: string) {
    if (tipo === "vendas") {
      this.members = this.allMembers.filter(
        user => user.novoPerfil.nome === "Vendedor" || user.novoPerfil.nome === "Vendedor e Cobrador"
      );
      this.supervisors = this.allSupervisors.filter(user => user.novoPerfil.nome === "Supervisor");
    } else if (tipo === "servicos") {
      this.members = this.allMembers.filter(user => user.novoPerfil.nome === "Virtus Service - APP");
      this.supervisors = this.allSupervisors.filter(user => user.novoPerfil.nome === "Virtus Service - Supervisor");
    } else {
      this.members = [];
      this.supervisors = [];
    }
  }

  async filterUsersByProfile(users: User[]) {
    this.allSupervisors = users
      .filter(user => user.novoPerfil.nome === "Supervisor" || user.novoPerfil.nome === "Virtus Service - Supervisor")
      .sort();
    this.allMembers = users.filter(
      user =>
        user.novoPerfil.nome === "Vendedor" ||
        user.novoPerfil.nome === "Vendedor e Cobrador" ||
        user.novoPerfil.nome === "Virtus Service - APP"
    );
    //-- Check if user has active team
    const asyncFilter = async arr => {
      const results = await Promise.all(arr.map(user => this.userHasNotActiveTeam(user._id)));

      return arr.filter((_v, index) => results[index]);
    };
    this.allMembers = await asyncFilter(this.allMembers);
    this.allMembers.sort();
  }

  private async userHasNotActiveTeam(userId: string) {
    const teams = await this.teamsService.getUserTeams(userId).toPromise();
    let hasActiveTeam = false;

    if (teams.length > 0) {
      hasActiveTeam = true;
    }

    return !hasActiveTeam;
  }

  userIsNotSelected(id: string) {
    let userNotSelected: Boolean = true;
    const activeMembers = this.team.membros.filter(member => member.deleted === undefined || member.deleted === false);
    const member = activeMembers.find(member => member._id === id);
    if (member) {
      userNotSelected = false;
    }

    return userNotSelected;
  }

  goBack(): void {
    this.router.navigateByUrl(`/teams/${this.env.selected.cnpj}`);
  }
}
